import { useState } from 'react';
import { NoddiDateRangePicker } from '../../../../Overlay/Date/NoddiDateRangePicker';
import type { FilterUnit } from '../../filterUnitType';
import { getActiveControlsCount } from '../../helper';
import type { TableFilterTranslations } from '../../tableTranslationTypes';
import { MobileFilterDrawer } from './FilterSidebar';
import { FilterToggleButton } from './FilterToggleButton';

type Props = {
  filters: FilterUnit<object>;
  /** Back to the first page: the filtered rows are a new list. */
  resetPagination: () => void;
  translations?: Partial<TableFilterTranslations>;
};

/**
 * A filter unit's Filters button and sheet, and its date range, for a table that keeps no filter state itself
 * (`NoddiStaticTable`). The unit's quick filter is the table's tray.
 */
export const FilterUnitControls = ({ filters: { controls, dateRange }, resetPagination, translations }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {controls.length > 0 && (
        <>
          <FilterToggleButton
            activeFiltersCount={getActiveControlsCount(controls)}
            filterSidebarOpen={open}
            setFilterSidebarOpen={setOpen}
            translations={translations}
          />
          <MobileFilterDrawer
            open={open}
            onOpenChange={setOpen}
            controls={controls}
            resetPagination={resetPagination}
            translations={translations}
          />
        </>
      )}
      {dateRange && (
        <NoddiDateRangePicker
          dateRange={dateRange.value}
          placeholder={dateRange.placeholder}
          showClearButton
          onDateChange={(range) => {
            resetPagination();
            dateRange.onChange(range);
          }}
        />
      )}
    </>
  );
};
